import { combineReducers } from '@reduxjs/toolkit';

import { feedbackReducer } from './feedback';
import { resolutionReducer } from './resolution';
import { searchReducer } from './search';
import { smartReplyReducer } from './smartReply';
import { suggestionReducer } from './suggestion';

export const elevioReducer = combineReducers({
  suggestions: suggestionReducer,
  feedback: feedbackReducer,
  search: searchReducer,
  resolution: resolutionReducer,
  aiResponse: smartReplyReducer,
});
